<template>
  <div class="search-bar">
    <form @submit.prevent>
      <div class="form-group">
        <input
          type="text"
          autocomplete="off"
          class="form-control"
          id="search-filter"
          :placeholder="_T('Search item')"
          v-model="searchItem"
        />
        <svg height="24" width="24">
          <use xlink:href="#Search" />
        </svg>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { eventBus } from '@/eventBus'
export default {
  name: 'SearchBar',
  data() {
    return {
      searchTerm: '',
    }
  },
  destroyed() {},

  computed: {
    ...mapGetters(['_T']),
    searchItem: {
      get() {
        return this.searchTerm
      },
      set(value) {
        this.searchTerm = value
        this.$store.commit('SET_ITEM_SEARCH_TERM', value)
      },
    },
  },
  mounted() {
    eventBus.$on('clear-search', () => {
      this.searchTerm = ''
      this.$store.commit('SET_ITEM_SEARCH_TERM', '')
    })
  },
}
</script>
<style lang="scss" scoped>
.search-bar {
  max-width: $px230;
  margin-left: auto;
  .form-group {
    position: relative;
    .form-control {
      border: $px2 solid $light-border;
      border-radius: $px4;
    }
    svg {
      position: absolute;
      right: $px15;
      top: 50%;
      transform: translateY(-50%);
      width: $px20;
    }
  }
  ::placeholder {
    color: #bdbdbd;
  }
}
</style>
